var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M18 6.967c0 .28-.22.5-.5.5H1.71l5.141 5.15c.199.19.199.51 0 .7a.473.473 0 01-.351.15.47.47 0 01-.35-.15l-6-6c-.2-.19-.2-.51 0-.7l6-6c.19-.2.51-.2.701 0 .199.19.199.51 0 .7L1.71 6.467H17.5c.28 0 .5.22.5.5z"
  })));
}
SvgBack.displayName = 'Back';
export default SvgBack;